<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->
<script>

import QwoachDialog from "@/core/components/Dialogs/QwoachDialog/QwoachDialog.vue";
import {DataStorageType} from "@/core/components/Wizard/DataStorageType";

export default {
	name: "BaseWizard",
	extends: QwoachDialog,

	data(){
		return {
			wizardLayout: null,
			activeStep: 0,
			wizardData: {},
		}
	},

	methods:{
		async wizardSteps(){
			throw new Error("BaseWizard: wizardSteps() is not implemented.")
		},

		analyticsEventActionName(){
			return "Wizard action clicked"
		},

		async onSaveState(){
			// return this.getWizardData()
		},

		async onRestoreState(data){
		},

		onRestoreStateForStep(stepIndex){

		},

		getGlobalObjectClass(){
			return null
		},

		getDataStorageType(){
			return DataStorageType.QUERY
		},

		removeSyncUrlParamInternal(queryKeys){
			let storageData = this.getDataStorageType()
			switch (storageData){
				case DataStorageType.SESSION_STORAGE:
					return this.$session.remove(this.wizardLayout.dataStorageKey)
				case DataStorageType.QUERY:
				default:
					return this.removeQuery(queryKeys)
			}
		},

		queryParamsToRemoveOnCloseInternal(){
			let res = []
			res.push(...this.queryParamsToRemoveOnClose())
			res.push(...this.wizardLayout.queryParamsToRemoveOnClose())
			return res
		},

		queryParamsToRemoveOnClose(){
			return []
		},

		analyticsPropsMethod() {
			return {
				category: "Wizard",
				...(this.analyticsProps || {}),
				...this.analyticsPropsInternal()

			}
		},

        async createWizardGlobalData(){
            return null
        },

		onWizardResult(wizardData){
			return wizardData
		},

		registerLayout(wizardLayout){
			this.wizardLayout = wizardLayout
		},


		getWizardData(){
			return this.wizardLayout.getWizardData()
		},


		async saveStateData(data){
			return this.wizardLayout.saveStateData(data)
		},

		getStateObject() {
			return this.wizardLayout.getStateObject()
		}
	},

    computed: {
        lastStepText() {
            return null
        }
    },
}
</script>

<style lang="scss">

</style>
